const RAW_API_URL = (process.env.REACT_APP_API_URL || "http://localhost:5000").replace(/\/+$/, "");
const API_BASE_URL = /\/api$/.test(RAW_API_URL) ? RAW_API_URL : `${RAW_API_URL}/api`;

const jsonFetch = async (url, options) => {
  const response = await fetch(url, options);
  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }
  return response.json();
};

export const getFournisseurs = (params = {}) => {
  const qs = new URLSearchParams(
    Object.fromEntries(
      Object.entries(params).filter(([, v]) => v !== undefined && v !== null && v !== "")
    )
  ).toString();
  return jsonFetch(`${API_BASE_URL}/fournisseurs${qs ? `?${qs}` : ""}`);
};

export const getFournisseurById = (id) =>
  jsonFetch(`${API_BASE_URL}/fournisseurs/${id}`);

export const getFournisseurYears = () =>
  jsonFetch(`${API_BASE_URL}/fournisseurs/years`);

export const createFournisseur = (fournisseurData) =>
  jsonFetch(`${API_BASE_URL}/fournisseurs`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(fournisseurData),
  });

export const updateFournisseur = (id, fournisseurData) =>
  jsonFetch(`${API_BASE_URL}/fournisseurs/${id}`, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(fournisseurData),
  });

export const deleteFournisseur = (id) =>
  jsonFetch(`${API_BASE_URL}/fournisseurs/${id}`, {
    method: "DELETE",
  });
